/* eslint-disable array-callback-return */
/* eslint-disable arrow-parens */
// import * as utils from '@/utils/utils';

import services from '../services/payment.js'
import { message } from 'antd'

const { getPaymentRecord, getPaymentNotice, getPaymentDetail, getArrearageDetail, getExpressSingleDetail } = services

const namespace = 'payment'

export default {
  namespace,
  state: {
    loading: false,
    paymentRecordData: {
      total: 0,
      list: [],
    },
    paymentNoticeData: {
      total: 0,
      list: [],
    },
    // 缴费详情
    paymentDetail: {},
    paymentDetailVisible: false,
    // 欠费详情
    arrearageDetail: {},
    arrearageDetailVisible: false,
    // 获取快递详情
    expressSingleDetail: {},
    expressSingleDetailVisible: false,
  },

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },

  effects: {
    // 更新数据
    *changeState({ payload, callback }, { put }) {
      yield put({
        type: 'updateState',
        payload: { ...payload },
      })
    },

    // 获取缴费记录
    *getPaymentRecord({ payload, callback }, { call, put }) {
      yield put({
        type: 'updateState',
        payload: { loading: true },
      })
      const res = yield call(getPaymentRecord, { ...payload })
      yield put({
        type: 'updateState',
        payload: {
          paymentRecordData: res.data,
          loading: false,
        },
      })
    },

    // 获取缴费通知
    *getPaymentNotice({ payload, callback }, { call, put }) {
      yield put({
        type: 'updateState',
        payload: { loading: true },
      })
      const res = yield call(getPaymentNotice, { ...payload })
      yield put({
        type: 'updateState',
        payload: {
          paymentNoticeData: res.data,
          loading: false,
        },
      })
    },

    // 获取缴费详情
    *getPaymentDetail({ payload, callback }, { call, put }) {
      yield put({
        type: 'updateState',
        payload: { loading: true },
      })
      const res = yield call(getPaymentDetail, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            paymentDetail: res.data,
            paymentDetailVisible: true,
            loading: false,
          },
        })
      }
    },

    // 获取欠费详情
    *getArrearageDetail({ payload, callback }, { call, put }) {
      yield put({
        type: 'updateState',
        payload: { loading: true },
      })
      const res = yield call(getArrearageDetail, { ...payload })
      yield put({
        type: 'updateState',
        payload: {
          arrearageDetail: res.data,
          arrearageDetailVisible: true,
          loading: false,
        },
      })
    },

    // 获取快递详情
    *getExpressSingleDetail({ payload, callback }, { call, put }) {
      yield put({
        type: 'updateState',
        payload: { loading: true },
      })
      const res = yield call(getExpressSingleDetail, { ...payload })
      yield put({
        type: 'updateState',
        payload: {
          expressSingleDetail: res.data,
          expressSingleDetailVisible: true,
          loading: false,
        },
      })
    },
  },
  // 订阅事件
  subscriptions: {},
}
